/** Priority entry as served by GET /flo/priorities. */
export interface FloPriority {
	rank: number;
	dimensionName: string;
	riskLevel: number;
	worstDepartments: string[];
}

/** Shape of the GET /flo/priorities response object (v2+). */
export interface FloPrioritiesResponse {
	priorities: FloPriority[];
	highRiskCount: number;
	dominantDepartment: string | null;
}

/**
 * Order-stable signature of a priority set; a different signature means meaningful "news". Shared
 * by the insight banner and the FAB callout so both agree on what re-alerts. Captures the ranking,
 * the dimensions AND each priority's worst department(s) — so a shift in where a risk concentrates
 * re-surfaces the banner, while minor risk-number jitter that changes none of these stays quiet.
 */
export function prioritySignatureOf(priorities: FloPriority[]): string {
	return priorities.map(p => `${p.rank}:${p.dimensionName}:${(p.worstDepartments ?? []).join(',')}`).join('|');
}

/**
 * Returns the human-readable high-risk count label.
 * 0 → "Nenhuma área em risco alto"; 1 → "1 área em risco alto"; n → "{n} áreas em risco alto".
 */
export function highRiskLabel(n: number): string {
	if (n === 0) return 'Nenhuma área em risco alto';
	return n === 1 ? '1 área em risco alto' : `${n} áreas em risco alto`;
}
